export default "__VITE_ASSET__BEPW_iRe__"